import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { CompanySize } from '@/types'
import { CustomSelectFieldGroup } from '@components-v2/molecules/CustomSelectFieldGroup'

type Props = {
  placeholder: string
  selectedCompanySize: CompanySize
  setFieldValue: (value: CompanySize) => void
}

export const CompanySizeSelectField2: FC<Props> = ({ placeholder, selectedCompanySize, setFieldValue }) => {
  const { t } = useTranslation(['angels-vcs-startups'])

  const onSelect = (value: CompanySize) => {
    setFieldValue(value)
  }

  const onUnselect = () => {
    setFieldValue(undefined)
  }

  const allItems = [
    { id: CompanySize.UNKNOWN, name: t('未設定') },
    { id: CompanySize.FROM_1_TO_10, name: t('10人未満') },
    { id: CompanySize.FROM_11_TO_50, name: t('11人以上50人未満') },
    { id: CompanySize.FROM_51_TO_200, name: t('51人以上200人未満') },
    { id: CompanySize.FROM_201_TO_500, name: t('201人以上500人未満') },
    { id: CompanySize.FROM_501_TO_1000, name: t('501人以上1000人未満') },
    { id: CompanySize.FROM_1001_TO_5000, name: t('1001人以上5000人未満') },
    { id: CompanySize.OVER_5000, name: t('5000人以上') },
  ]

  const selectedItem = allItems.find((item) => selectedCompanySize === item.id)

  const selectableItems = allItems.map((item) => ({
    instance: item,
    isSelected: selectedCompanySize === item.id,
  }))

  return (
    <CustomSelectFieldGroup
      placeholder={placeholder}
      onSelect={onSelect}
      onUnselect={onUnselect}
      selectedItems={selectedItem ? [selectedItem] : []}
      selectableItems={selectableItems}
      onUnselectAll={onUnselect}
    />
  )
}
